import { render, staticRenderFns } from "./ShowRichTextData.vue?vue&type=template&id=9332df64"
import script from "./ShowRichTextData.vue?vue&type=script&lang=js"
export * from "./ShowRichTextData.vue?vue&type=script&lang=js"
import style0 from "./ShowRichTextData.vue?vue&type=style&index=0&id=9332df64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports